export const button = `
  <button
    class="Button Button--primary"
    type="button"
    :skin="skins.buttons"
    :name="fdata.field"
    :value="fdata.title"
    :text="fdata.title"
    @click="buttonClick(fdata.actions)"
  >
    <span class="Button__text">{{ fdata.title }}</span>
  </button>`

export const link = `
  <a
   class='{{ fdata.class }} {{ class }}'
   :disabled='buttonDisabled'
   @click.prevent='buttonClick(fdata.actions)'
  >
    {{ fdata.title }}
  </a>
`

export const teditableText = `
  <p
    class='{{ fdata.class }} {{ class }}'
    @click='buttonClick(fdata.actions)'
  >
    {{ fdata.title }}
  </p>
`



// WEBPACK FOOTER //
// ./src/components/inputs/buttons/_shared/partials.js